import React, { Component } from "react";
import moment from "moment";
import _ from "lodash";

import cubejs from "../../cube";
import LineChartWrap from "../../charts/LineChartWrap";
import YandexMapWrap from "../../charts/YandexMapWrap";
import Loader from "../../components/Loader";
import { MainWrapper } from "../../components/MainWrapper";
import { TabMainTitle } from "../../components/TabMainTitle";
import { FilterWrapper } from "../../components/FilterWrapper";
import { FilterItem } from "../../components/FilterItemNew/FilterItem";
import { DatePickerR } from "../../components/DatePickerR";
import { SelectList } from "../../components/SelectList";
import { RowWrapper } from "../../components/RowWrapper";
import { ChartCard } from "../../components/ChartCard";
import i18n from "../../i18n";

const cubejsApi = cubejs({ appId: 1 });

export default class Ecology2 extends Component {
  constructor() {
    super();
    this.state = {
      filtersData: {
        "DStation.pnzNumber": {
          key: "DStation.pnzNumber",
          title: "Станция",
          options: [],
          values: [],
        },
        "SmartECOKazgidromet.measureNameRu": {
          key: "SmartECOKazgidromet.measureNameRu",
          single: true,
          title: i18n.t("education.childrenKindergartens.elements"),
          options: [],
          values: [],
        },
        "DStation.locality": {
          key: "DStation.locality",
          single: true,
          title: i18n.t("publicSafety.dtp.town"),
          options: [],
          values: [],
        },
      },
      filters: [
        {
          member: "SmartECOKazgidromet.dateTime",
          operator: "inDateRange",
          values: [moment().subtract(2, "d"), moment()],
        },
      ],
      cardData: {
        lineChartData: [],
        series: [],
        data: [],
        resultSet: [],
      },
      mapData: [],
      additionalInformation: ["SmartECOKazgidromet.postAdditionalInformation"],
      byElements: false,
      currentArea: {
        pnzNumber: [],
        locality: [],
        measureNameRu: [],
      },
      range: [moment().subtract(2, "d"), moment()],
      loading: true,
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    this.getFiltersData();
    this.getCardData();
    this.getMapData();
  }

  getFiltersData = async () => {
    const { filtersData, filters } = this.state;
    let newFiltersData = filtersData;
    const filterNames = Object.keys(filtersData);

    let reqs = [];
    filterNames.forEach((f) => {
      let newFilters = filters.filter((e) => e.member !== f);
      reqs.push(
        cubejsApi.load(
          newFilters.length !== 0
            ? {
                dimensions: [f],
                filters: newFilters,
              }
            : {
                dimensions: [f],
              }
        )
      );
    });

    const responses = await Promise.all(reqs);
    responses.forEach((res, i) => {
      newFiltersData = {
        ...newFiltersData,
        [filterNames[i]]: {
          ...newFiltersData[filterNames[i]],
          options: res.rawData().map((d) => d[filterNames[i]]),
        },
      };
    });
    this.setState({ filtersData: newFiltersData });
  };

  getMapData = () => {
    const { filters, additionalInformation } = this.state;
    let request = [
      {
        measures: [],
        dimensions: [
          "DStation.pnzNumber",
          "DStation.id",
          "DStation.x",
          "DStation.y",
          "DStation.type",
          "DStation.dataType",
          "SmartECOKazgidromet.postAdditionalInformation",
        ],
        filters,
        limit: 50000,
      },
      {
        measures: ["SmartECOKazgidromet.valueMax"],
        dimensions: [
          "SmartECOKazgidromet.measureNameRu",
          "SmartECOKazgidromet.maxpokazatel",
          ...additionalInformation,
        ],
        filters,
        limit: 50000,
      },
    ];

    Promise.all(request.map((e) => cubejsApi.load(e))).then((r) => {
      let measures = _.groupBy(
        r[1].rawData(),
        "SmartECOKazgidromet.postAdditionalInformation"
      );

      let keys = [];
      Object.keys(measures).forEach((el) => {
        let data = { post: el };
        measures[el].some(
          (e) =>
            e["SmartECOKazgidromet.maxpokazatel"] !== null &&
            e["SmartECOKazgidromet.valueMax"] >
              e["SmartECOKazgidromet.maxpokazatel"]
        )
          ? (data["color"] = "#f44336")
          : (data["color"] = "#32CD66");

        keys.push(data);
      });

      let data = r[0].rawData().map((el) => {
        const colorInfo = keys.find(
          (e) => e.post === el["SmartECOKazgidromet.postAdditionalInformation"]
        );

        return {
          ...el,
          "DStation.pnzNumber": el["DStation.pnzNumber"],
          "DStation.type": el["DStation.type"],
          "DStation.dataType": el["DStation.dataType"],
          color: colorInfo?.color ?? "#32CD66",
          ballon: {
            hintContent: el["DStation.pnzNumber"],
          },
        };
      });

      this.setState({ mapData: data });
    });
  };

  async getCardData() {
    const { filters, additionalInformation, byElements } = this.state;
    let request = {
      measures: ["SmartECOKazgidromet.value"],
      dimensions: [
        "SmartECOKazgidromet.measureNameRu",
        "SmartECOKazgidromet.maxpokazatel",
        "SmartECOKazgidromet.dateTime.hour",
      ],
      filters,
      order: {
        "SmartECOKazgidromet.maxpokazatel": "asc",
      },
      limit: 50000,
    };
    if (byElements) request.dimensions.push(additionalInformation[0]);
    let resultSet = await cubejsApi.load(request);

    let lineChartData = resultSet.chartPivot().map((d) => {
      const obj = { ...d, x: new Date(d.x) };
      if (obj.x[2] === 0) {
        obj["SmartECOKazgidromet.value"] = null;
      }
      for (const [key, value] of Object.entries(obj)) {
        if (typeof value === "number" && value === 0) {
          obj[key] = null;
        }
      }
      return obj;
    });

    this.setState({
      cardData: {
        lineChartData,
        resultSet,
        series: resultSet ? resultSet.seriesNames() : [],
        data: resultSet.rawData(),
      },
      loading: false,
    });
  }

  applyFilters = (filter, values, single) => {
    let { filtersData, filters, currentArea } = this.state;
    let newFilters = [...filters].filter((e) => e.member !== "DStation.id");

    values = Array.isArray(values) ? values : [values];
    values = values.includes(undefined) ? [] : values;

    if (values.length !== 0 && !newFilters.find((x) => x.member === filter)) {
      newFilters.push({
        member: filter,
        operator: "equals",
        values: values,
      });
    } else if (
      newFilters.find((x) => x.member === filter) &&
      values.length !== 0
    ) {
      newFilters[
        newFilters.findIndex((x) => x.member === filter)
      ].values = values;
    } else {
      newFilters.splice(
        newFilters.findIndex((x) => x.member === filter),
        1
      );
    }

    if (filters.find((e) => e.member !== "DStation.id")) {
      currentArea.pnzNumber = [];
      this.setState({});
    }

    this.setState(
      {
        filtersData: {
          ...filtersData,
          [filter]: {
            ...filtersData[filter],
            values,
          },
        },
        additionalInformation: values
          ? ["SmartECOKazgidromet.postAdditionalInformation"]
          : [],
        currentArea: {
          pnzNumber: filters.find((e) => e.member !== "DStation.id")
            ? filter === "DStation.pnzNumber"
              ? values
              : []
            : this.state.currentArea.pnzNumber,
          locality:
            filter === "DStation.locality"
              ? values
              : this.state.currentArea.locality,
          measureNameRu:
            filter === "SmartECOKazgidromet.measureNameRu"
              ? values
              : this.state.currentArea.measureNameRu,
        },

        filters: newFilters,
        loading: true,
        mapData: [],
      },
      () => this.checkByElements()
    );
  };

  checkByElements = () => {
    let { byElements, filters } = this.state;
    let newByElements = byElements;
    if (
      filters.find((e) => e.member === "SmartECOKazgidromet.measureNameRu") &&
      !filters.find((e) => e.member === "DStation.pnzNumber") &&
      !filters.find((e) => e.member === "DStation.locality")
    )
      newByElements = true;
    else newByElements = false;

    this.setState(
      {
        byElements: newByElements,
        loading: true,
      },
      () => this.getData()
    );
  };

  onChangeDatePicker = (range) => {
    let { filters } = this.state;
    let newFilters = [...filters].filter((e) => e.member !== "DStation.id");
    newFilters[
      filters.findIndex((x) => x.member === "SmartECOKazgidromet.dateTime")
    ].values = range;
    this.setState(
      { filters: newFilters, range, loading: true, mapData: [] },
      () => this.getData()
    );
  };

  loadDetails = (items) => {
    let { filters, mapData } = this.state;
    this.setState(
      {
        filters: [
          ...filters.filter((e) => e.member !== "DStation.id"),
          {
            member: "DStation.id",
            operator: "equals",
            values: Array.isArray(items)
              ? items.map((el) => el["DStation.id"].toString())
              : [items.toString()],
          },
        ],
        currentArea: {
          ...this.state.currentArea,
          pnzNumber: Array.isArray(items)
            ? _.uniqBy(items, "DStation.pnzNumber").map(
                (e) => e["DStation.pnzNumber"]
              )
            : [
                mapData.find((e) => e["DStation.id"] === items)[
                  "DStation.pnzNumber"
                ],
              ],
        },
        byElements: true,
        loading: true,
      },
      () => this.getCardData()
    );
  };

  returnMapColor(value, maxValue) {
    if (maxValue === 0) return "#32CD66";
    else if (value > maxValue) return "#f44336";
    else return "#32CD66";
  }

  returnCurrentArea() {
    let { currentArea } = this.state;

    return currentArea.pnzNumber.length !== 0 ||
      currentArea.locality.length !== 0 ||
      currentArea.measureNameRu.length
      ? currentArea.pnzNumber.length !== 0
        ? " " + currentArea.pnzNumber.join()
        : currentArea.locality.length !== 0
        ? " Средние показатели по " + currentArea.locality.join()
        : " Показатели по Карагандинской области"
      : " Средние показатели по Карагандинской области";
  }

  returnTitle(color) {
    switch (color) {
      case "#32CD66":
        return "Низкий уровень загрязнения";
      case "#f44336":
        return "Критический уровень загрязнения";
      case "#2196f3":
        return "Станция";
      default:
        break;
    }
  }

  returnMarkerColor(source, type) {
    let color;
    if ((source === "Казгидромет") & (type === "автоматика")) {
      color = "#B3DDCC";
    } else if ((source === "Казгидромет") & (type === "ручные")) {
      color = "#3D91BE";
    } else if ((source === "Смарт ЭКО") & (type === "автоматика")) {
      color = "#9c27b0";
    } else if ((source === "Смарт ЭКО") & (type === "ручные")) {
      color = "#F997BA";
    }
    return color;
  }

  render() {
    const { filtersData, range, cardData } = this.state;

    return (
      <MainWrapper>
        <TabMainTitle>
          {i18n.t("caseNames.airPollution")}:{" "}
          {i18n.t("education.childrenKindergartens.averageIndicatorsForPeriod")}{" "}
          <span className="date-period">
            {range[0].format("DD.MM.YYYY")}{" "}
            <span style={{ color: "#fff" }}>{i18n.t("component.to")} </span>{" "}
            {range[1].format("DD.MM.YYYY")}
          </span>
        </TabMainTitle>

        <FilterWrapper>
          <FilterItem>
            <SelectList
              label={filtersData["DStation.pnzNumber"].title + ":"}
              defaultValue={this.state.currentArea.pnzNumber}
              mode="multiple"
              onChange={(value) => {
                this.applyFilters(
                  filtersData["DStation.pnzNumber"].key,
                  value,
                  filtersData["DStation.pnzNumber"].single
                );
              }}
              allowClear
              size="small"
              list={filtersData["DStation.pnzNumber"].options}
            />
          </FilterItem>
          <FilterItem>
            <SelectList
              label={
                filtersData["SmartECOKazgidromet.measureNameRu"].title + ":"
              }
              onChange={(value) => {
                this.applyFilters(
                  filtersData["SmartECOKazgidromet.measureNameRu"].key,
                  value,
                  filtersData["SmartECOKazgidromet.measureNameRu"].single
                );
              }}
              allowClear
              size="small"
              list={filtersData["SmartECOKazgidromet.measureNameRu"].options}
            />
          </FilterItem>
          <FilterItem>
            <SelectList
              label={filtersData["DStation.locality"].title + ":"}
              onChange={(value) => {
                this.applyFilters(
                  filtersData["DStation.locality"].key,
                  value,
                  filtersData["DStation.locality"].single
                );
              }}
              allowClear
              size="small"
              list={filtersData["DStation.locality"].options}
            />
          </FilterItem>
          <FilterItem>
            <DatePickerR
              label={i18n.t("economy.income.period")}
              onChange={(range) => {
                this.onChangeDatePicker(range);
              }}
              value={range}
              size="small"
              separator="—"
            />
          </FilterItem>
        </FilterWrapper>
        <RowWrapper>
          <div style={{ width: "30%" }}>
            <YandexMapWrap
              objects={this.state.mapData}
              idDataKey="DStation.id"
              xDataKey="DStation.x"
              yDataKey="DStation.y"
              height="550px"
              zoom={10}
              center={[46.9605, 54.0069]}
              handleClick={(items) => {
                this.loadDetails(items);
              }}
              onClusterClick={(items) => {
                this.loadDetails(items);
              }}
            />
            <div
              style={{
                display: "flex",
                marginTop: "10px",
                flexWrap: "wrap",
              }}
            >
              {Array.from(new Set(this.state.mapData.map((el) => el.color)))
                .map((el) => ({
                  color: el,
                  "DStation.dataType": this.state.mapData.find(
                    (e) => e.color === el
                  )["DStation.dataType"],
                  "DStation.type": this.state.mapData.find(
                    (e) => e.color === el
                  )["DStation.type"],
                }))
                .map((item) => (
                  <div
                    style={{
                      display: "flex",
                      marginRight: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: item.color,
                        height: "15px",
                        borderRadius: "10",
                        width: "15px",
                        marginRight: "5px",
                      }}
                    ></div>
                    <div>{this.returnTitle(item.color)}</div>
                  </div>
                ))}
            </div>
          </div>
          <div
            style={{
              width: "69%",
              marginLeft: 10,
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            {!this.state.loading ? (
              <>
                {cardData.series.length !== 0
                  ? cardData.series.map((s, i) => {
                      const measureName = s.title.split(", ")[0];

                      const getThreshold = (name) => {
                        if (!name) return null;
                        const normalized = name
                          .toLowerCase()
                          .replace(/[\s₁₂₃₄₅₆₇₈₉₀,\.()\-]/g, "");

                        if (
                          normalized.includes("h2s") ||
                          normalized.includes("h₂s") ||
                          normalized.includes("сероводород")
                        )
                          return 0.008;
                        if (
                          normalized.includes("pm25") ||
                          normalized.includes("pm2,5")
                        )
                          return 0.16;
                        if (normalized.includes("pm10")) return 0.3;
                        if (
                          normalized.includes("co") ||
                          normalized.includes("оксидуглерода") ||
                          normalized.includes("окси��углерода")
                        )
                          return 5;
                        if (
                          normalized.includes("so2") ||
                          normalized.includes("so₂") ||
                          normalized.includes("диоксидсеры") ||
                          normalized.includes("диоксидсеры")
                        )
                          return 0.5;
                        if (
                          normalized.includes("no2") ||
                          normalized.includes("no₂") ||
                          normalized.includes("диоксид") ||
                          normalized.includes("диоксидазота")
                        )
                          return 0.2;
                        if (
                          normalized.includes("no") ||
                          normalized.includes("оксид") ||
                          normalized.includes("оксидазота")
                        )
                          return 0.4;
                        // dust / пыль
                        if (
                          normalized.includes("пыль") ||
                          normalized.includes("пыл")
                        )
                          return 0.5;

                        return null;
                      };

                      let criticalValue = getThreshold(measureName);
                      console.log(
                        "Ecology measure critical:",
                        measureName,
                        criticalValue
                      );

                      // Additional debugging: show series descriptor and sample data keys
                      console.log("Ecology series:", s);
                      console.log(
                        "Ecology lineChartData sample keys:",
                        (cardData.lineChartData || [])[0]
                      );
                      if (criticalValue == null) {
                        // Try to find a matching raw data entry to extract maxpokazatel
                        let matched = (cardData.data || []).find((el) => {
                          const name = el["SmartECOKazgidromet.measureNameRu"];
                          if (name && name.includes(measureName)) return true;
                          return Object.values(el).some(
                            (v) =>
                              typeof v === "string" && v.includes(measureName)
                          );
                        });

                        if (matched) {
                          const maxKey = Object.keys(matched).find((k) =>
                            k.toLowerCase().includes("maxpokazatel")
                          );
                          if (maxKey) criticalValue = Number(matched[maxKey]);
                        }
                      }

                      // Resolve actual data key present in lineChartData for this series
                      const sample = (cardData.lineChartData || [])[0] || {};
                      const dataKeys = Object.keys(sample || {});
                      let seriesKey = s.key || s.title;
                      if (!dataKeys.includes(seriesKey)) {
                        // try to find a key that contains the measure name and the raw measure field
                        const measurePart =
                          s.title && s.title.split(", ")[0]
                            ? s.title.split(", ")[0].toLowerCase()
                            : null;
                        const found = dataKeys.find((k) => {
                          const kl = k.toLowerCase();
                          if (measurePart && !kl.includes(measurePart))
                            return false;
                          return (
                            kl.includes("smartecokazgidromet.value") ||
                            kl.includes("value")
                          );
                        });
                        if (found) seriesKey = found;
                      }
                      console.log(
                        "Resolved seriesKey for",
                        s.title,
                        "=>",
                        seriesKey
                      );
                      const filteredData = (cardData.lineChartData || [])
                        .map((d) => Number(d[seriesKey]))
                        .filter((v) => isFinite(v));
                      let maxFilteredValue =
                        filteredData.length > 0
                          ? Math.max.apply(null, filteredData)
                          : 0;
                      if (maxFilteredValue >= 1000000) {
                        return (
                          <ChartCard style={{ width: "30%", flex: "unset" }}>
                            <h3
                              style={{
                                textAlign: "center",
                                color: "#b9b9b9",
                              }}
                            >
                              Данные не обновлены
                            </h3>
                            <h3
                              style={{
                                textAlign: "center",
                                color: "#b9b9b9",
                              }}
                            >
                              ({s.title.split(", ")[0]})
                            </h3>
                          </ChartCard>
                        );
                      }
                      return (
                        <ChartCard
                          title={
                            this.state.byElements
                              ? s.title.split(", ")[0] +
                                " - " +
                                s.title.split(", ")[2]
                              : s.title.split(", ")[0]
                          }
                          style={{ width: "30%", flex: "unset" }}
                        >
                          <LineChartWrap
                            critical={criticalValue}
                            id={`SmartECOKazgidromet${i}`}
                            data={cardData.lineChartData}
                            category="x"
                            yUnit={s.title.split(", ")[1].trim()}
                            values={[
                              {
                                ...s,
                                key: seriesKey,
                                title: s.title.split(", ")[0],
                              },
                            ]}
                            height={300}
                            color="#00bcd4"
                            scroll={{ start: 0, end: 1 }}
                            showLegend={false}
                            totals={
                              criticalValue != null &&
                              isFinite(Number(criticalValue)) &&
                              Number(criticalValue) > 0
                                ? [
                                    {
                                      key: Number(criticalValue),
                                      title: "Критическое значение",
                                      value: Number(criticalValue),
                                      color: "red",
                                    },
                                  ]
                                : []
                            }
                          />
                        </ChartCard>
                      );
                    })
                  : "Данные по выбранной станции отсутствуют"}
              </>
            ) : (
              <Loader imgSize={30} fontSize={25} />
            )}
          </div>
        </RowWrapper>
      </MainWrapper>
    );
  }
}
